import { Breadcrumbs } from '@ocm_customer/account_navigation';
import { useAccountCrumbs } from '@thd-olt-component-react/customer-account-navigation';
import { Typography } from '@one-thd/sui-atomic-components';
import { Col, Row } from '@thd-olt-component-react/core-ui';
import React from 'react';
import { ExperienceContext } from '@thd-nucleus/experience-context';

interface HeadingProps {
  title: string;
  isQuoteMobile?: boolean;
}

export const Heading = ({ title, isQuoteMobile }: HeadingProps) => {
  const { isConsumerApp }: any = React.useContext(ExperienceContext);

  // a helper for retrieving the leading 2 crumbs
  const crumbs = useAccountCrumbs([
    {
      label: 'Job Quotes',
      path: '/quote/list',
    },
  ]);

  if (
    typeof window !== 'undefined' &&
    window.location?.pathname.includes('/quote/details')
  ) {
    crumbs.push({
      label: 'Quote Detail',
      path: '',
    });
  }

  return (
    <Row>
      <Col className="nav-heading">
        {!isConsumerApp ? <Breadcrumbs crumbs={crumbs} /> : null}
        {!isQuoteMobile && (
          <Typography
            weight="display"
            variant="h1"
            uppercase
            data-testid="page-title"
          >
            {title.toUpperCase() || 'JOB QUOTES'}
          </Typography>
        )}
      </Col>
    </Row>
  );
};
